import { notification } from 'antd'
import { useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { UpdateTicket } from '@types'
import { notifyTicketUpdateError } from '@utils'

import { TicketsApi } from './api'

const useUpdateTicket = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_update_ticket.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS_COUNT)
    queryClient.invalidateQueries(QUERY_KEYS.MATERIALS)
  }

  const updateTicket = async (ticketId: number, updatedData: UpdateTicket) => {
    try {
      await TicketsApi.updateTicket(ticketId, updatedData)
      onUpdateSuccess()
      notification.success({
        message: 'Se realizo la modificacion correctamente',
      })
    } catch (error) {
      notifyTicketUpdateError(error, t, { noActiveRoutePreffix: tPreffix })
    }
  }

  return {
    updateTicket,
  }
}

export { useUpdateTicket }
